import { aiAgentIdentitySingleAction, aiAgentStilingueApiHost, aiAgentStilingueApiEnvironment, } from 'app.constants';
export const AiAgentConstants = {
    CURRENT_AI_AGENTS_VERSION: '0.1',
    BLOCK_TYPE_FOR_TRACKING: 'ai-agent',
    STATE_ID_PREFIX: 'ai-agent:',
    DEFAULT_BLOCK_TITLE: 'AI Agent',
    AI_AGENT_IDENTITY_SINGLE_ACTION: aiAgentIdentitySingleAction,
    AI_AGENT_API_HOST: aiAgentStilingueApiHost,
    AI_AGENT_API_HOST_ENVIRONMENT: aiAgentStilingueApiEnvironment,
    DEFAULT_GROUNDING_MCP: 'grounding-mcp',
};
export var AgentState;
(function (AgentState) {
    AgentState["DEVELOPMENT"] = "DEV";
    AgentState["PUBLISHED"] = "PUBLISHED";
})(AgentState || (AgentState = {}));
